/** Shared Vite env reads used by the SPA and unit tests. */

function defaultApiUrl(): string {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:8000";
  }
  return "https://api.academiceye.net";
}

export const API_URL = import.meta.env.VITE_API_URL || defaultApiUrl();

export const AUTH_SYNC_INTERVAL_MS = Number(
  import.meta.env.VITE_AUTH_SYNC_INTERVAL_MS || 30000,
);

/** Public asset base without trailing slash (Vite BASE_URL always ends with /). */
export const PUBLIC_URL = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
